// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/product/product-check/product-check-aggregate/product-check-aggregate.scss
// module id = 505
// module chunks = 0